// @ts-nocheck
import { capitalize, flatten } from 'lodash';
import { GeoDictionaryTagsConfig } from 'mercator-cartography-api-client/lib/interfaces/geoDictionary.types';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { useQueryFetch } from 'sonata-react-components';
import { getFormattedFilterGroups } from 'sonata-static-storage/lib/helpers/stats.helpers';

import { getCountriesWithEvents, getSelectedCampaigns } from '@/store/selectors/reporting.selectors';
import { getUserRoles } from '@/store/selectors/resources.selectors';
import { getCurrentUser } from '@/store/selectors/user.selectors';
import { getStatsTableVariableFilters } from '@/ts-helpers/stats.helper';
import { getCartographyDictionary } from '@/ts-resources/reporting.resources';

type Props = {
  type: 'footfallAttribution' | 'stats' | 'viewability';
};

type Result = {
  options: {
    id: string;
    label: string;
  }[];
  variables: string[];
};

export const useReportingVariableFilters = ({ type }: Props): Result => {
  const { formatMessage } = useIntl();
  const user = useSelector(getCurrentUser);
  const userRoles = useSelector(getUserRoles);
  const campaigns = useSelector(getSelectedCampaigns);
  const countries: string[] = useSelector(getCountriesWithEvents);

  const queryKey = `statsTable-cartography-${countries.join('|')}`;

  const { data: cartographyDictionaryTagConfigsData } = useQueryFetch<GeoDictionaryTagsConfig[]>(
    queryKey,
    async () => {
      const demographyCountry = await getCartographyDictionary(countries);
      return flatten(demographyCountry.map(cConfig => cConfig.tagsConfig as GeoDictionaryTagsConfig));
    },
    {
      enabled: countries.length === 1,
      placeholderData: [
        {
          id: 'level0',
          name: 'Country'
        }
      ]
    }
  );

  const variables = getStatsTableVariableFilters(
    type,
    user,
    userRoles,
    campaigns,
    cartographyDictionaryTagConfigsData,
    true
  );

  const options = variables.map((variable: string) => ({
    id: getFormattedFilterGroups([variable])[0].replace('..', '.'),
    label: variable.startsWith('cartoPyramid')
      ? cartographyDictionaryTagConfigsData?.find(op => variable.includes(op.id!))?.name || variable
      : formatMessage({
          defaultMessage: capitalize(variable),
          id: `reportingStats.cpyTable${capitalize(variable)}`
        })
  }));

  return {
    options,
    variables
  };
};
